/**
 * Copyright © 2018-present Emu Analytics
 */

import { IPipelineMetric } from './api-interfaces';
import { BaseEndpoints } from './base.endpoints';
import { Client } from './client';

export class PipelineMetricEndpoints extends BaseEndpoints<IPipelineMetric> {
  constructor(client: Client, pipelineId: string, componentId: string) {
    super(client, `pipelines/${pipelineId}/components/${componentId}/metrics`);
  }
}
